class StickyOverlay extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.fadeOutElements = this.querySelectorAll('.util-WillFade')
    this.observeElements()
  }

  observeElements () {
    const options = {
      root: null,
      rootMargin: '-100px 0px 100% 0px',
      threshold: [...Array(101)].map((_, i) => i / 100),
    }

    const callback = entries => {
      entries.forEach(entry => {
        entry.target.style.opacity = entry.intersectionRatio
      })
    }

    const observer = new IntersectionObserver(callback, options)

    this.fadeOutElements.forEach(elem => {
      observer.observe(elem)
    })
  }
}

if (!customElements.get('sticky-overlay')) {
  customElements.define('sticky-overlay', StickyOverlay)
}
